export const getPathForAirport = (slug) => `/airport-parking/${slug}`;
export const getPathForProduct = (airportSlug, productSlug) => `/airport-parking/${airportSlug}/${productSlug}`;
export const getPathForAirportSearchResults = (airportSlug) => `/airport-parking/${airportSlug}/search-results`;
export const getPathForBlogPost = (category, slug) => category ? `/blog/${category}/${slug}` : `/blog/${slug}`;
export const getPathForCategory = (slug) => `/blog/${slug}`;
